var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("div", { staticClass: "pay_head" }, [
        _c("p", { staticClass: "pay_code" }, [_vm._v("付款码")]),
        _vm._v(" "),
        _c("p", { staticClass: "pay_show" }, [_vm._v("结账时出示会员卡")]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "pay_num",
            on: {
              click: function($event) {
                return _vm.clickT("2")
              }
            }
          },
          [_vm._v("卡号密钥")]
        )
      ]),
      _vm._v(" "),
      _vm.message == "1"
        ? _c("div", { staticClass: "SweepBox" }, [
            _c(
              "div",
              { staticClass: "add" },
              [_vm.Bar ? _c("longcode", { attrs: { onecode: 1 } }) : _vm._e()],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.message == "2"
        ? _c("div", { staticClass: "textBox" }, [
            _c(
              "p",
              {
                staticClass: "close_modal",
                on: {
                  click: function($event) {
                    return _vm.clickT("1")
                  }
                }
              },
              [_vm._v("X")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "padding-bottom": "5px", color: "gray" } },
              [
                _c("span", [_vm._v("卡号")]),
                _vm._v(" "),
                _c("span", { staticClass: "hui" }, [
                  _vm._v(_vm._s(_vm.tateData.VIPNO))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "padding-bottom": "5px", color: "gray" } },
              [
                _c("span", [_vm._v("密钥")]),
                _vm._v(" "),
                _c("span", { staticClass: "hui" }, [
                  _vm._v(_vm._s(_vm.tateData.VeriFicationCode))
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.message == "2" ? _c("div", { staticClass: "mask" }) : _vm._e(),
      _vm._v(" "),
      _vm.load ? _c("loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53d78f2d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53d78f2d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/PaymentCode/index.vue
// module id = null
// module chunks = 